"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.planningValidator = void 0;
var types_1 = require("../types/");
exports.planningValidator = (_a = {},
    _a[types_1.ActionType.EMAIL] = function (planning) { return planning.mails.length > 0; },
    _a[types_1.ActionType.SMS] = function (planning) { return planning.phones.length > 0; },
    _a[types_1.ActionType.PUSH] = function (planning) { return planning.userIds.length > 0; },
    _a[types_1.ActionType.JOB] = function (planning) { return planning.userIds.length > 0; },
    _a);
